import React, { useState } from "react";
import NavHeader from "./NavHeader";
import useLogout from "./useLogout";

import "../../sass/zeplin/ClinicHeader.scss";

import {
  AccountsIcon,
  CalendarIcon,
  ProfileIcon,
  BookedIcon,
  ChatIcon,
  HelpCenterIcon,
} from "./ClinicHeader";
import { ICONS } from "./constants/swal.constants";
import GenericModal from "./GenericModal";
import {
  Calendar,
  Users,
  CalendarCheck,
  User,
  MessageSquare,
  HelpCircle,
  LogOut,
} from "lucide-react";
import NewNavLink from "./NewNavLink";
const links = [
  {
    pathname: "/rep/accounts",
    Img: AccountsIcon,
    name: "Accounts",
    descriptor: "Manage your Offices",
    icon: Users,
  },
  {
    pathname: "/rep/appointments",
    Img: CalendarIcon,
    name: "Appointments",
    descriptor: "Browse Available Appointments",
    icon: Calendar,
  },
  {
    pathname: "/booked",
    Img: BookedIcon,
    name: "Booked",
    descriptor: "Your Booked Appointments",
    icon: CalendarCheck,
  },
  {
    pathname: "/rep/settings",
    Img: ProfileIcon,
    name: "Profile",
    descriptor: "Your settings",
    icon: User,
  },
  {
    pathname: "/chat",
    Img: ChatIcon,
    name: "Chat",
    descriptor: "Messages",
    icon: MessageSquare,
  },
  {
    pathname: "/help-center",
    Img: HelpCenterIcon,
    name: "Help Center",
    descriptor: "Guides & FAQs",
    icon: HelpCircle,
  },

  // { pathname: "messages", Img: AnnouncementsIcon, name: "Announcements" }
];

const RepHeader = () => {
  const [genericModalData, setGenericModalData] = useState({
    show: false,
  });
  const showLogoutSuccess = () => {
    setGenericModalData({
      show: true,
      title: "Goodbye",
      subtext: "See you next time!",
      icon: ICONS.checkMark,
    });
  };
  const showLogoutError = () => {
    setGenericModalData({
      show: true,
      title: "Oops!",
      subtext: "Some error occurred",
      icon: ICONS.error,
    });
  };
  const hideModal = () => {
    setGenericModalData((prevState) => ({ ...prevState, show: false }));
  };

  const logOut = useLogout(
    "/login",
    showLogoutSuccess,
    showLogoutError,
    hideModal,
  );
  return (
    <>
      {genericModalData.show && (
        <GenericModal
          show={genericModalData.show}
          onHide={hideModal}
          title={genericModalData?.title || ""}
          subtext={genericModalData?.subtext || ""}
          icon={genericModalData?.icon || undefined}
          hideBtn
        />
      )}
      <NavHeader
        links={links}
        renderLinks={(fromSidebar) => {
          return (
            <NewNavLink
              onClick={() => {
                return logOut();
              }}
              fromSidebar={fromSidebar}
              item={{
                pathname: "/login",
                name: "Logout",
                icon: LogOut,
              }}
            />
          );
        }}
      />
    </>
  );
};

export default RepHeader;
